module.exports = __webpack_public_path__ + "static/media/icon-job-verde.6ebed0b1.svg";